import React from 'react';

import image from './mybot1.png';

const Message=(props) => {

 /* return (
    <div className="col s12 m8 offset-m2 l6 offset-l3">
    <div className="card-panel grey lighten-5 z-depth-1">
        <div className="row valign-wrapper">
            {props.speaks==='bot' &&
            <div className="col s2">
                <a href="/" className="btn-floating btn-large waves-effect waves-light blue">{props.speaks}</a>
            </div>
            }
            <div className="col s10">
              <span className="black-text">
                {props.text}
              </span>
            </div>
            {props.speaks==='user' &&
            <div className="col s2">
                <a href="/" className="btn-floating btn-large waves-effect waves-light blue">{props.speaks}</a>
            </div>
            }
        </div>
    </div>
    </div>
  );*/

  return (
  <div class="container-fluid">
  <div className="card-body">
      <div className="row align-items-start"  style={{font:'15px Arial, sans-serif'}}>
          {props.speaks==='bot' &&
          <div className="col-16" style={{color:'#2F4F4F',font:'16px Arial, sans-serif',backgroundColor:'#F5F5F5'}}>
               <span  >
                  {props.speaks}:
                   &nbsp; 
                 {props.text}
            </span>
            </div>
          }
          <div>
             <br></br>
          </div>
          {props.speaks==='me' &&
          <div className="col-16" style={{color:'#96be0d',backgroundColor:'#F5F5F5',font:'16px Arial'}}>
              <span >
              {props.speaks}:
              &nbsp; 
               {props.text}
            </span>
            </div>
          }
                   
      </div>
  </div>
  </div>
);
}

export default Message;